import React, { FC } from 'react';
import styled from '@emotion/styled';

import { type, spacing, getBackgroundTheme } from '../../style';
import breakpoints from 'theme/material/breakpoints';

const Loading = styled('div')(() => ({
  ...spacing.MARGIN_TOP_SM,
  // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
  ...spacing.PADDING_H,
  ...type.LG,
  textAlign: 'center',
  [breakpoints.down(479.05)]: {
    display: 'block',
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 9999,
    width: '100%',
    height: '100%',
    backgroundColor: getBackgroundTheme().surface,
    marginTop: 0,
    paddingTop: '20px',
    color: '#E21D4A',
  },
}));

const LoadingMsg: FC<{ msg: string }> = props => {
  const { msg } = props;

  return <Loading>{msg}...</Loading>;
};

export default LoadingMsg;
